import React, { useRef } from "react"
import "./style.scss"
import Button from "../../../../../components/Button"
import { useForm, Controller } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import { useDispatch, useSelector } from "react-redux"
import strings from "../../../../../translation"
import { uploadLogo } from "../../redux/actions"
const AddLogo = ({ setIsShown }) => {
  const fileInputRef = useRef(null)

  const schema = yup.object().shape({
    logo: yup
      .mixed()
      .required(`${strings.LOGO_IS_REQUIRED}`)
      .test("fileSize", `${strings.FILE_TOO_LARGE}`, value => {
        return value && value[0] && value[0].size <= 5 * 1024 * 1024 // 5MB
      })
      .test("fileType", `${strings.UNSUPPORTED_FILE_FORMAT}`, value => {
        return (
          value &&
          value[0] &&
          ["image/jpeg", "image/png", "image/svg+xml", "image/jpg"].includes(value[0].type)
        )
      })
  })

  const {
    control,
    handleSubmit,
    reset,
    watch,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange"
  })

  const selectedFile = watch("logo")?.[0] || null

  const dispatch = useDispatch()
  const loading = useSelector(state => state.Settings.uploadLogoLoading)

  const onSubmit = data => {
    const formData = new FormData()
    formData.append("logo", data.logo[0])

    dispatch(uploadLogo(formData))
    
    setTimeout(() => {
      setIsShown("")
      reset()
    }, 1000);
   
  }

  return (
    <div className="change-password-container mt-3">
      <h2 className="heading-text">{strings.ADD_LOGO}</h2>

      <div className="input-container">
        <Controller
  name="logo"
  control={control}
  render={({ field }) => (
    <div className="custom-file-picker">
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={e => field.onChange(e.target.files)}
      />
      <div className="file-picker-content">
        <p className="selected-file-name">
          {selectedFile ? selectedFile.name : strings.NO_FILE_CHOSEN}
        </p>
        <Button
          title={strings.CHOOSE_FILE}
          className="board-btn choose-file-btn"
          onClick={() => fileInputRef.current && fileInputRef.current.click()}
        />
      </div>
      {errors.logo && (
        <p className="error-text">{errors.logo.message}</p>
      )}
    </div>
  )}
/>
      </div>

      <div className="buttons-container mt-5">
        <Button
          showSpinner={loading}
          onClick={handleSubmit(onSubmit)}
          title={strings.UPLOAD_LOGO}
          className="board-btn full-btn mb-3"
        />
        <Button
          onClick={() => setIsShown("")}
          title={strings.CANCEL}
          className="board-btn full-btn yellow-outline-btn"
        />
      </div>
    </div>
  )
}

export default AddLogo
